module.exports = __webpack_public_path__ + "static/fonts/notokr-medium.81bd542.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard/assest/font/notosanskr/notokr-medium.woff
// module id = R0sO
// module chunks = 0